/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Hero_BreadcrumbInputs */

const es_cap_hero_breadcrumb = /** @type {(inputs: Cap_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitanes`)
};

const gl_cap_hero_breadcrumb = /** @type {(inputs: Cap_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patróns`)
};

const en_cap_hero_breadcrumb = /** @type {(inputs: Cap_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skippers`)
};

/**
* | output |
* | --- |
* | "Skippers" |
*
* @param {Cap_Hero_BreadcrumbInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_hero_breadcrumb = /** @type {((inputs?: Cap_Hero_BreadcrumbInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Hero_BreadcrumbInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_hero_breadcrumb(inputs)
	if (locale === "en") return en_cap_hero_breadcrumb(inputs)
	return es_cap_hero_breadcrumb(inputs)
});